var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rendezvous-grid"},[_c('div',{staticClass:"grid-item"},[_c('LoadingSpinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }